import { WIDGET_NAME } from '@sitegen/common/constants';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import { getTrackingFlowSubType } from 'utils/analytics';

export const getAnalyticsDataOnPlatformClick = (
    widgetName: WIDGET_NAME,
    platform: PLATFORM_TYPES
) => ({
    flowStep: 'platform selection',
    flowSubType: getTrackingFlowSubType(widgetName),
    category: CATEGORY.INTERACTION,
    action: `platform selection : ${platform}`
});
